import React, { useEffect, useState } from "react";
import { fetchData } from "../../helpers/externapi";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";

export default function NewReportList() {
    const [loading, setLoading] = useState(false);
    const [tableloading, setTableLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [schedulingId, setSchedulingId] = useState(null); // which report is currently being scheduled

    const navigate = useNavigate();
    let UserId = localStorage.getItem("UserId");

    const tableHeads = ["Report Name", "Description", "ACTIONS"];

    const tableElements =
        filteredData && filteredData.length > 0
            ? filteredData.map((data) => [
                <div
                    style={{ whiteSpace: "normal", textAlign: "start", display: "block" }}
                >
                    {data.ReportName}
                </div>,
                data.Description,
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button
                        className="btn btn-sm"
                        onClick={() => generateReport(data)}
                        disabled={schedulingId === data.ReportsId}
                        style={{
                            backgroundColor:
                                schedulingId === data.ReportsId ? "#a0aec0" : "#344CB7",
                            color: "#fff",
                            border: "none",
                            padding: "5px 11px",
                            borderRadius: "8px",
                            cursor:
                                schedulingId === data.ReportsId ? "not-allowed" : "pointer",
                            fontSize: "12px",
                            minWidth: "130px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px",
                            transition: "background-color 0.3s ease, transform 0.2s ease",
                        }}
                        onMouseOver={(e) => {
                            if (schedulingId !== data.ReportsId) {
                                e.currentTarget.style.backgroundColor = "#577BC1";
                                e.currentTarget.style.transform = "scale(1.05)";
                            }
                        }}
                        onMouseOut={(e) => {
                            if (schedulingId !== data.ReportsId) {
                                e.currentTarget.style.backgroundColor = "#344CB7";
                                e.currentTarget.style.transform = "scale(1)";
                            }
                        }}
                    >
                        {schedulingId === data.ReportsId ? (
                            <>
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    style={{ width: "12px", height: "12px" }}
                                />
                                Scheduling...
                            </>
                        ) : (
                            "Schedule Report"
                        )}
                    </button>
                </div>,
            ])
            : [];

    const getMemberCardCountData = async () => {
        setLoading(true);
        try {
            const eventCountData = await fetchData(
                `CommonRowCount/GetTableRowCount`,
                { tableName: "Reports" }
            );
            const total = eventCountData[0]?.CountOfRecords || 0;
            setTotalCount(total);
        } catch (error) {
            console.error("Error fetching count data:", error);
        } finally {
            setLoading(false);
        }
    };

    const generateReport = async (data) => {
        setSchedulingId(data.ReportsId);
        try {
            await fetchData("lambdaAPI/Reports/ReportsCreation", {
                ReportsId: data.ReportsId,
                UserId,
            });

            // Store the newly triggered ReportsId so ReportsData can poll for it
            localStorage.setItem("pendingReportId", String(data.ReportsId));
            localStorage.setItem("pendingReportScheduledAt", String(Date.now()));

            navigate("/reports/list/reportsData");
        } catch (error) {
            console.error("Error scheduling report:", error);
            setSchedulingId(null);
        }
    };

    const getMemberCardData = async () => {
        setTableLoading(true);
        try {
            const cardData = await fetchData("lambdaAPI/Reports/all", {
                skip: 0,
                take: 0,
            });
            setFilteredData(cardData.map((c) => ({ ...c })));
        } catch (err) {
            console.error("Error fetching card data:", err);
        } finally {
            setTableLoading(false);
        }
    };

    useEffect(() => {
        getMemberCardCountData();
        getMemberCardData();
    }, []);

    const styles = {
        table: { width: "100%", borderCollapse: "collapse" },
        th: {
            padding: "10px",
            border: "1px solid #ddd",
            textAlign: "center",
            backgroundColor: "#f2f2f2",
            color: "#333",
            textTransform: "uppercase",
            fontSize: "11px",
            letterSpacing: "1px",
            fontWeight: "bold",
        },
        td: {
            padding: "5px",
            border: "1px solid #ddd",
            fontSize: "14px",
            whiteSpace: "normal",
            maxWidth: "200px",
        },
        headerRow: { backgroundColor: "#f9f9f9" },
    };

    const skeletonloading = () => (
        <>
            <style>{shimmerStyle}</style>
            <div className="shimmer-container shimmer">
                <h6 className="shimmer-text"></h6>
            </div>
            <table className="shimmer-container shimmer">
                <tbody>
                    {Array.from({ length: 6 }).map((_, rowIndex) => (
                        <tr key={rowIndex} className="shimmer-row">
                            {Array.from({ length: 6 }).map((_, colIndex) => (
                                <td key={colIndex} className="shimmer-cell">
                                    <h6 className="shimmer-text2"></h6>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );

    return (
        <>
            {loading && skeletonloading()}
            {!loading && (
                <div className="row mt-2">
                    <div
                        className="col-xl-12 col-lg-12 col-md-12 order-0 order-md-1"
                        style={{ margin: 0, padding: 0 }}
                    >
                        <div
                            className="card mb-4"
                            style={{ opacity: loading ? 0.5 : 1, margin: 0, padding: 0 }}
                        >
                            <div className="card-body" style={{ margin: 0, padding: 0 }}>
                                {(loading || tableloading) && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            backgroundColor: "rgba(255,255,255,0.7)",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            zIndex: 1000,
                                        }}
                                    >
                                        <CircularProgress />
                                    </div>
                                )}

                                {!loading && filteredData.length === 0 && (
                                    <div style={{ textAlign: "center", padding: "20px" }}>
                                        There are no records to display.
                                    </div>
                                )}

                                {!loading && filteredData.length > 0 && (
                                    <div
                                        className="table-responsive text-nowrap"
                                        style={{ margin: 0, padding: 0 }}
                                    >
                                        <table style={{ ...styles.table, margin: 0, padding: 0 }}>
                                            <thead>
                                                <tr style={{ ...styles.headerRow, margin: 0, padding: 0 }}>
                                                    {tableHeads.map((head, index) => (
                                                        <th key={`header-${index}`} style={styles.th}>
                                                            {head}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tableElements.map((row, rowIndex) => (
                                                    <tr key={`row-${rowIndex}`} style={{ margin: 0, padding: 0 }}>
                                                        {row.map((data, colIndex) => (
                                                            <td
                                                                key={`${rowIndex}-${colIndex}`}
                                                                style={styles.td}
                                                                className="text-center"
                                                            >
                                                                {data}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation: shimmer 1.0s infinite linear forwards;
    background: linear-gradient(to right, #f0f0f0 8%, #fafafa 18%, #f0f0f0 33%);
    background-size: 1000px 104px;
    position: relative;
    overflow: hidden;
  }
  .shimmer-container { background-color: #F7F7F7; border-radius: 4px; height: 50px; width: 100%; margin: 15px; }
  .shimmer-text2 { background-color: #C8C8C8; border-radius: 4px; height: 15px; width: 55%; margin: 15px 0 0 15px; position: relative; left: 10%; bottom: 10%; }
  .shimmer-text { background-color: #C8C8C8; border-radius: 4px; height: 15px; width: 15%; margin: 15px 0 0 15px; }
  .shimmer-row { display: flex; }
  .shimmer-cell { flex: 1; padding: 10px; height: 50px; background-color: #F7F7F7; border-radius: 4px; margin: 5px; }
`;